import styles from "./MobileNumber.module.css";
import { usePhoneCredentials, useVerifyPhone, useLoginModals } from "@hooks/login";

const MobileNumber = () => {
  const { goToSendOtp } = useLoginModals();
  const {
    phoneNumber,
    countryCode,
    isPhoneComplete,
    updatePhoneNumber,
    updateCountryCode,
    getPhoneData,
  } = usePhoneCredentials();

  const { error, verify, isVerifying } = useVerifyPhone({
    onSuccess: goToSendOtp,
  });

  const handleStartClick = () => verify(getPhoneData());

  return (
    <div className={styles.mobile_input_container}>
      <div className={styles.input_group}>
        <select
          value={countryCode}
          className={styles.dial_code_select}
          onChange={(e) => updateCountryCode(e.target.value)}
        >
          <option value="+91">+91</option>
          <option value="+1">+1</option>
        </select>

        <input
          type="tel"
          className={styles.mobile_number_input}
          placeholder="Enter your mobile number"
          onChange={(e) => updatePhoneNumber(e.target.value)}
          value={phoneNumber}
          maxLength={10}
        />

        <button
          type="button"
          className={styles.btn_primary}
          disabled={!isPhoneComplete || isVerifying}
          onClick={handleStartClick}
        >
          START
        </button>
      </div>
      {error && <p role="alert">{error}</p>}
    </div>
  );
};

export default MobileNumber;
